module.exports = __webpack_public_path__ + "static/media/sachin.3620f1a7.csv";